module.exports = __webpack_public_path__ + "62bc9bcf96e7abb6e21278b2e9714817.svg";